import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { AnalyseSchemaView } from '../components/views'

function AnalyseSchema() {
    return (
        <div className="analyseSchema">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Analyse Schema'} />
                <AnalyseSchemaView />
            </MainView>
        </div>
    )
}

export default AnalyseSchema
